module.exports = __webpack_public_path__ + "static/img/cc4e98554bb8dfc6e77c3328a6c0ba63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T22.jpg
// module id = E6P0
// module chunks = 1